export default __webpack_public_path__ + "static/media/info-circle-error.a37b601d.svg";